import { render, staticRenderFns } from "./LoginRoute.vue?vue&type=template&id=5ff61d70&scoped=true&"
import script from "./LoginRoute.vue?vue&type=script&lang=js&"
export * from "./LoginRoute.vue?vue&type=script&lang=js&"
import style0 from "./LoginRoute.vue?vue&type=style&index=0&id=5ff61d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff61d70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VForm,VImg,VTextField})
